<div class="table-wrapper">
    <aumico-table [options]="options" [data]="data" [delegate]="this"> </aumico-table>
    <div *ngIf="errorMessage" class="error">
        <p>{{ (errorMessage | async)?.statusText }}</p>
    </div>
</div>
